import React, { useContext } from "react";
import { useState, useEffect } from "react";
import { Tab, Nav, Offcanvas } from 'react-bootstrap';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Notification_Card from "../Notification/Notification_Card/Notification_Card";
import "./Notification.css"
import { Context } from "../../../utils/context";

const Notification = ({ handleClose, show }) => {

  const { getData, userdata, IMG_URL } = useContext(Context);

  const [notificationData, setNotifData] = useState([]);

  const getNotificationData = async () => {
    const response = await getData(
      `/projectmanagement/project-summary/notification`
    );
    await setNotifData(response?.data?.notificationData);
  };


  useEffect(() => {
    getNotificationData();
  }, []);

  return (
    <section className='Notification'>
      <Offcanvas
        className="notification-offcanvas"
        placement="end"
        show={show}
        onHide={handleClose}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Notifications</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="notifications-banner-img-holder">
            <img
              className="notifications-banner-img"
              src={process.env.PUBLIC_URL + "/assets/Image/photos/projectmanage.jpg"}
              alt="..."
            />
          </div>

          <div className="notification-tab-holder">
            <Notification_Card notificationData={notificationData} IMG_URL={IMG_URL} />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
};

export default Notification;
